<template>
  <div>
    <div class="rj-layout-header">
      <div class="rj-layout-logo" />
      <div class="rj-layout-title">
        <slot name="title" />
      </div>
      <div class="rj-layout-right">
        <slot />
      </div>
    </div>
  </div>
</template>
<script type="es6">
export default {
  data () {
    return {};
  },
  components: {},
  computed: {},
  methods: {},
  mounted () {

  }
};
</script>
<style lang="scss">
  @import '../../style/var';
  @include namespace(layout-header){
    height: $layoutHeaderHeight;
    background-color: $layoutHeaderBackColor;
    border-bottom: $layoutHeaderBorder;
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    z-index: 50;
  }
  @include namespace(layout-logo){
    position: absolute;
    height: $layoutHeaderHeight;
    width: $layoutMenuWidth;
    top: 0;
    left: 0;
    background-image: url("./logo.png");
    background-repeat: no-repeat;
    background-size: auto 45%;
    background-position: center center;
    &:after{
      content: ' ';
      position: absolute;
      height: 30%;
      width: 1px;
      background-color: $--border-color-base;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  @include namespace(layout-right){
    position: absolute;
    height: $layoutHeaderHeight;
    top: 0;
    right: 0;
  }
  @include namespace(layout-title){
    position: absolute;
    height: $layoutHeaderHeight;
    top: 0;
    left: $layoutMenuWidth;
  }
</style>
